import React from "react";
import { Button, Card, Header, Grid } from "semantic-ui-react";
import {genreOptions, levelOptionsDict} from "../../../constants";
import {capitalizeFirstLetter} from "../../../utils/utils";

export const Contact = ({ profile }) => {
    const profile_links = profile?.profile_links ? JSON.parse(profile.profile_links) : [];
    let fullName = profile?.family_name? profile.family_name.toUpperCase() : '';
    fullName += profile?.given_name ? (', ' + profile.given_name) : '';
    fullName = fullName === '' ? profile?.full_name ?? '' : fullName;
    const languages = profile?.languages ? JSON.parse(profile.languages) : [];
    const gender = profile?.gender ?? null;

    const getGenderPrettyText = (gender) => {
        return genreOptions.find((genre) => genre.key === gender)?.text;
    };
    const getLanguagePrettyText = (language) => {
        return capitalizeFirstLetter(language)
    }
    return (
        <Card fluid>
            <Card.Content>
                <Card.Header as="h1">Contact</Card.Header>
                {fullName && (
                    <div style={{ display: "flex", paddingTop: "1rem", flexDirection: "row", gap: "1rem" }}>
                        <Header as="h3">{fullName}</Header>
                    </div>
                )}

                <div style={{ display: "flex", paddingTop: "1rem", flexWrap: "wrap", gap: "0.75rem" }}>
                    {profile?.orcid && <Button color="green" content="Orcid" icon="linkify" labelPosition="left" target="_blank" href={profile?.orcid} />}
                    {profile?.linkedin && <Button content="LinkedIn" color="linkedin" icon="linkedin" labelPosition="left" target="_blank" href={profile?.linkedin} />}
                    {profile_links.map((item, idx) => (
                        <Button key={idx} content={item.title} icon="linkify" labelPosition="left" target="_blank" href={item.url} />
                    ))}
                </div>
                {profile?.email && (
                    <div style={{ display: "flex", paddingTop: "1rem", flexDirection: "row", gap: "1rem" }}>
                        <Header as="h4">Email: </Header>
                        <p>{profile.email}</p>
                    </div>
                )}
                {gender && (
                    <div style={{ display: "flex", paddingTop: "1rem", flexDirection: "row", gap: "1rem" }}>
                        <Header as="h4">Gender: </Header>
                        <p>{getGenderPrettyText(gender)}</p>
                    </div>
                )}

                {languages.length > 0 && (
                    <div style={{ display: "flex", paddingTop: "1rem", flexDirection: "column"}}>
                        <Header as="h4">Languages:</Header>
                        {languages.map((userLang) => {
                            return (
                                <Grid columns={2} stackable>
                                    <Grid.Column style={{maxWidth: "12rem"}}>
                                        <Header as="h5">{getLanguagePrettyText(userLang.language ?? "Lang. not available")}</Header>
                                    </Grid.Column>
                                    <Grid.Column>
                                                <p>{" " + levelOptionsDict[userLang.level] ?? "Level not available"}</p>
                                    </Grid.Column>
                            </Grid>
                            )})
                        }
                    </div>
                )}
            </Card.Content>
        </Card>
    );
};
